"use client";
import React, { ReactElement, ReactNode, Ref, forwardRef, memo } from "react";
import {
  FormControlLabel,
  FormControlLabelProps,
  Radio,
  RadioProps,
} from "@mui/material";

const AppRadio = forwardRef(
  (
    { sx, formControlLabelProps, label = "", ...otherProps }: AppRadioProps,
    ref: Ref<HTMLInputElement>
  ) => {
    return (
      <FormControlLabel
        control={
          <Radio
            inputRef={ref}
            {...otherProps}
            sx={{
              padding: "8px",
              ...sx,
            }}
          />
        }
        label={label}
        {...formControlLabelProps}
        sx={{
          gap: "0px",
          margin: 0,
          ...formControlLabelProps?.sx,
        }}
      />
    );
  }
);
AppRadio.displayName = "AppRadio";
export default memo(AppRadio);
export type AppRadioProps = RadioProps & {
  label?: string | ReactElement | ReactNode;
  formControlLabelProps?: Omit<FormControlLabelProps, "control" | "label">;
};
